export const shopProductsSortOptions = {
  name: 'name',
  price: 'price',
};
